import React from 'react';

const DwriCalculationsTab = () => {
    return (
        <div className="utah-design-system">
             <h3>Calculations</h3>
             <p>Calculations content goes here.</p>
        </div>
    );
};

export default DwriCalculationsTab;